import React from 'react';
import cx from 'classnames';
import styled from 'styled-components';
import NoContentSvg from '@features/assets/imgs/no_content.svg';
import { useTranslation } from '@jupiter-app/plugin-i18n';

const NoContentComponent = styled.div`
  width: 268px;
`;
const Img = styled.img`
  width: 200px;
  height: 200px;
  margin-bottom: 12px;
`;
const Title = styled.div`
  margin-bottom: 4px;
`;

interface NoContentPageProps {
  className?: string;
}

const NoContentPage = (props: NoContentPageProps) => {
  const { className } = props;
  const { t } = useTranslation();
  return (
    <NoContentComponent
      className={cx(className, 'flex flex-col items-center justify-center')}>
      <Img src={NoContentSvg} alt={'no content page error image'} />
      <Title className={'font-semibold text-18 text-center'}>
        {t('academy_content_not_exist')}
      </Title>
      <div
        className={'font-regular text-14 text-center'}
        style={{ color: '#777D99' }}>
        {t('seller_university_article_not_exist_page_content')}
      </div>
    </NoContentComponent>
  );
};

export default NoContentPage;
